import React, { useState, useRef } from 'react';
import { MuiColorInput } from 'mui-color-input';
import { ClickAwayListener } from '@mui/material';
import './ColorSwatch.css';

interface ColorSwatchProps {
  color: string;
  onChange?: (color: string) => void;
  size?: number;
  className?: string;
}

const ColorSwatch: React.FC<ColorSwatchProps> = ({
  color,
  onChange,
  size = 32,
  className = '',
}) => {
  const [showHex, setShowHex] = useState(false);
  const isPickerOpenRef = useRef(false);

  const handleClickAway = () => {
    if (isPickerOpenRef.current) {
      isPickerOpenRef.current = false;
      // picker closes via MuiColorInput's internal handler
    } else {
      setShowHex(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <span className={`color-swatch-wrapper ${className}`}>
        <MuiColorInput
          format="hex"
          value={color.startsWith('#') ? color : `#${color}`}
          onChange={(newValue) => onChange?.(newValue)}
          variant="standard"
          isAlphaHidden
          disablePopover={false}
          sx={{
            width: showHex ? 98 : size,
            minWidth: size,
            transition: 'width 0.2s ease',
            '& .MuiInputBase-root': {
              gap: '6px',
              cursor: 'pointer',
            },
            '& .MuiInputBase-root::before': { display: 'none' },
            '& .MuiInputBase-root::after': { display: 'none' },
            '& .MuiInputBase-input': {
              height: 20,
              width: showHex ? 60 : 0,
              padding: 0,
              color: 'var(--text-primary)',
              fontSize: 12,
              transition: 'width 0.2s ease',
              overflow: 'visible',
            },
            '& .MuiColorInput-Button': {
              width: size,
              height: size,
              minWidth: size,
              borderRadius: 0,
              border: '1px solid var(--input-border)',
              padding: 0,
              flexShrink: 0,
            },
          }}
          PopoverProps={{
            slotProps: {
              paper: {
                style: { width: 250 },
              } as React.HTMLAttributes<HTMLDivElement>,
            },
            onFocus: () => setShowHex(true),
            TransitionProps: {
              onEnter: () => {
                isPickerOpenRef.current = true;
                setShowHex(true);
              },
              onExited: () => {
                isPickerOpenRef.current = false;
                setShowHex(false);
              },
            },
          }}
        />
      </span>
    </ClickAwayListener>
  );
};

export default ColorSwatch;